<template> 
  <div v-bind:id="canvas_id" style="position: static; border: 0px solid blue;  display:flex; flex-direction:row; justify-content:center" ></div>
</template>
 
<script>     
  import * as d3 from "d3"; 
  var width = 650, height = 400, margin = 60;
  var radius = Math.min(width, height) / 2 - margin;    
  var pie = d3.pie().startAngle(-0.8).endAngle(2*Math.PI-0.8)
              .value(function(d)   { return d.value.count; })
              .sort(function(a, b) { return d3.descending(a.value.count, b.value.count)}) ;

  var arc = d3.arc() 
              .innerRadius(0)
              .outerRadius(radius)
              .startAngle( (d) => {return d.startAngle} )
              .endAngle( (d) => {return d.endAngle} );

  var outerArc =  d3.arc() 
                    .innerRadius(radius * 0.9)
                    .outerRadius(radius * 0.9)
                    .startAngle( (d) => {return d.startAngle} )
                    .endAngle( (d) => {return d.endAngle} );

  function midAngle(d){
    return 0.5 * (d.endAngle + d.startAngle) ;
  }
      
    
  function wrap(s1, s2) {  
    var lines = s1.split('_') 
    var vo    = -1 * Math.floor(lines.length/2) + 1 // Vertical Offset 
    
    var newStr = "<text>"
    if (lines.length>10) {
      let i = 0;
      for (i; i < lines.length; i++) { 
        if (i==0) {
          newStr = newStr + "<tspan x='0' dy='" + vo + "em'>" +lines[i] + "</tspan>";  
        } else if (i+1==lines.length) {
          newStr = newStr + "<tspan x='0' dy='1em'>" +lines[i] + " (" + s2 + ")</tspan>";  
        } else {
          newStr = newStr + "<tspan x='0' dy='1em'>" +lines[i] + "</tspan>"; 
        } 
      } 
      //newStr = newStr + "<tspan x='0' dy='" + (i-vo) + "em'>(" + s2 + ")</tspan></text>"  
    } else {
      newStr = newStr + s1 + " (" + s2 + ")</text>"  
      
    } 
    return newStr
  } 
  
  export default {
    name: 'pieChart', 
    props: ['canvas_id', "title"],
    methods: { 
      draw: function (canvas_id, data) {  
        
        var pieData =  pie(d3.entries(data)) ;  

        var color = d3.scaleOrdinal()
                      .domain(Object.keys(pieData))
                      .range(d3.schemeCategory10);

        var slices =  d3.select("#"+canvas_id)
                        .select(".slices")
                        .selectAll('path')
                        .data(pieData); 
        slices.exit().remove() 
        slices.enter()
              .append('path')
              .merge(slices)
              .transition()
              .duration(1000)
              .attrTween("d", function(d) {
                  this._current   = this._current || d;
                  var interpolate = d3.interpolate(this._current, d);
                  this._current   = interpolate(0);
                  return function(t) {
                    return arc(interpolate(t));
                  };
              })
              .attr('fill', function(d){ return(color(d.data.key)) })
              .attr("stroke", "white")
              .style("stroke-width", "2px")
              .style("opacity", 1); 


        var labels = d3.select("#"+canvas_id)
                       .select(".labels")
                       .selectAll('a')
                       .data(pieData)
        labels.enter()
              .append("a")
              .merge(labels) 
                .attr("dy", ".35em")
                .attr("href", function(d) {   
                    return d.data.value.url ; 
                })
                .html(function(d) {   
                    return wrap(d.data.key, d.data.value.count)
                })
                .transition().duration(1000)
                .attrTween("transform", function(d) { //
                  this._current = this._current || d;
                  var interpolate = d3.interpolate(this._current, d);
                  this._current = interpolate(0);
                  return function(t) {
                    var d2 = interpolate(t); 
                    var pos = outerArc.centroid(d2);
                    pos[0] = radius * (midAngle(d2) < Math.PI ? 1 : -1);
                    return "translate("+ pos +")";
                  };
                })
                .styleTween("text-anchor", function(d){
                  this._current = this._current || d;
                  var interpolate = d3.interpolate(this._current, d); 
                  this._current = interpolate(0);
                  return function(t) {
                    var d2 = interpolate(t);
                    return midAngle(d2) < Math.PI ? "start" : "end";
                  };
                }) 
        labels.exit().remove(); 
        

        var line =  d3.select("#"+canvas_id)
                      .select(".lines")
                      .selectAll("polyline")
                      .data(pieData);
        line.enter()
          .append("polyline")
          .merge(line)
            .attr('fill',"none")
            .attr('stroke',"black")
            .transition()
            .duration(1000)
            .attrTween("points", function(d){
              this._current = this._current || d;
              var interpolate = d3.interpolate(this._current, d); 
              this._current = interpolate(0);
              return function(t) {
                var d2 = interpolate(t);
                var pos = outerArc.centroid(d2);
                pos[0] = radius * 0.95 * (midAngle(d2) < Math.PI ? 1 : -1);
                return [arc.centroid(d2), outerArc.centroid(d2), pos];
              };
            });
        line.exit().remove();  

      }
    }, 

    mounted () {  
      var svg = d3.select("#"+this.canvas_id)
                  .append("svg")
                    .attr("width", width)
                    .attr("height", height)
                    .attr("margin", margin)
                    //.attr("style", "border: 1px solid red;")
                    .attr("radius", radius);   
      svg.append("text")
            .attr("transform", "translate(100,0)")
            .attr("x",  0)
            .attr("y", 60)
            .attr("font-size", "2em")
            .attr("font-weight", "bold") 
            .text(this.title) 
      svg.append("g")
            .attr("class", "slices")
            .attr("transform", "translate(" + width / 2 + "," + (+height/2+30) + ")");
      svg.append("g")
            .attr("class", "labels")
            .attr("transform", "translate(" + width / 2 + "," + (+height/2+30) + ")");
      svg.append("g")
            .attr("class", "lines")
            .attr("transform", "translate(" + width / 2 + "," + (+height/2+30) + ")"); 
    }
  }  
 
               
</script> 
 
<style scoped>    
</style> 